import { WidgetErrorModel } from '../models/widget-error.model';
import { WidgetAuthErrorEnum } from 'src/app/widget-auth/models/widget-auth-error.enum';

// default config
export const defaultAuthErrorConfig: WidgetErrorModel = {
  title: 'Your BioDigital Human embed requires proper authentication.',
  description: ''
};

// custom user defined messages based on auth error type
export const authErrorConfig: { [key: string]: WidgetErrorModel } = {
  [WidgetAuthErrorEnum.InvalidUAID]: {
    title: 'Authentication Issues',
    description: 'Your Human Widget has invalid user credentials.',
    url: 'https://support.biodigital.com'
  }
};
